<template>
  <base-layout :title="$t('addressList.myAddress')" :hideFooter="false">
      <template slot="main">
          <div class="address-list-page" ref="listMain" @touchend="pageTouchEnd" @touchstart="pageTouchStart">
              <!-- loading加载状态容器 -->
              <loading :text="$t('comm.gettingAddressList')" v-if="isLoading && !addressList.length" :message="errMsg"/>
              <div v-else>
                  <ul v-if="addressList && addressList.length > 0">
                      <li
                          v-for="info in addressList"
                          class="address-list"
                          :key="Math.random()"
                          :class="{focus:info.id == defaultId}"
                      >
                          <div class="address-info">
                              <div class="address-location">{{ info.name }}</div>
                              <div class="address-location-plate">
                                  {{ info.originInfo.pickupPointName ? `${info.originInfo.pickupPointName}取餐` : info.originInfo.detailAddress }}
                              </div>
                              <div class="address-info-content">
                                  <strong>{{ info.originInfo.consignName }}</strong>
                                  <span>{{ info.originInfo.consignTel }}</span>
                              </div>
                          </div>
                          <div class="address-action">
                              <div class="address-radio" @click="selectDefaultAddress(info)">
                                  <i></i>
                                  <span>{{ $t('addressList.defaultAddress') }}</span>
                              </div>
                              <div class="address-action-data" @click="CDP_track(info,'编辑')">
                                  <router-link
                                      tag="span"
                                      :to="{
                                      path:'/address/update',
                                      query:{
                                          id:info.id
                                      }
                                  }"
                                  >
                                      <i class="dmicon dm-bianji"></i> {{ $t('addressList.edit') }}
                                  </router-link>
                                  <span @click="remove(info)">
                  <i class="dmicon dm-lajixiang"></i> {{ $t('addressList.delete') }}
                </span>
                              </div>
                          </div>
                      </li>
                  </ul>
                  <div v-else class="error-message">
                      <img src="~@assets/img/comm/dominos-loading.png"/>
                      <!--<i class="dmicon dm-xiankuangjiazaishibaidaitiicon"></i>-->
                      <p>{{ $t('addressList.currentlyNoAddress') }}...</p>
                  </div>
              </div>
          </div>
      </template>
      <template slot="footer">
          <router-link tag="div" class="address-add" to="/address/add">
              <button type="button" @click="CDP_track({},'新增')">{{ $t('addressList.addNewAddress') }}</button>
          </router-link>
      </template>
  </base-layout>
</template>

<script>
import {Dialog, Toast} from "vant";
import addressStore from "@comm/store/address.store";
import baseLayout from "@comm/view/layout/baseLayout";
// loading加载
import loading from "@components/comm/loading";
// 多语言字典
import {address as pageI18n} from "@config/i18n/page/address";

// 检查是否App内
const isApp = window.isApp || window.cordova;

export default {
  name: 'myAddressList',
  components: {
      Dialog,
      loading,
      baseLayout
  },
  data() {
      return {
          // 页面标题
          // title: "地址列表",
          isLoading: true,
          errMsg: null,
          // 地址列表
          addressList: [],
      };
  },
  created() {
      // 加载当前页面的i18n字典配置
      this.$loadI18nConfig(pageI18n);
      this.$pageLoad(this.initData);
  },
  computed: {
      // 默认的id
      defaultId() {
          return (this.addressList.find(info => info.originInfo.isDefault) || {}).id;
      }
  },
  methods: {
      initData() {
          // 不使用缓存策略
          // if (this.addressList.length) return (this.isLoading = false);
          // 获用户地址列表
          addressStore.dispatch("getAddressList", true).then(
              (addressList) => { 
                  this.isLoading = false;
                  // 地址列表
                  this.addressList = addressList;
                  this.scrollShim();
              },
              err => {
                  this.errMsg = err;
                  if (this.addressList.length) return this.isLoading = false;
              }
          );
      },
      // 地址默认选择
      selectDefaultAddress(info) {
          if (this.isLoading) return;
          // 检查是否不合法地址
          if (info.illegal) {
              return Dialog.alert({
                  message: '亲！此地址需要完善！',
                  confirmButtonText: '去完善',
                  confirmButtonColor: 'red',
              }).then(() => {
                  // on close
                  this.$router.push({
                      path: '/address/update',
                      query: {
                          id: info.id,
                          // action: 'update'
                      }
                  })
              });
          }

          this.isLoading = true;
          // 删除
          this.$service("setDefaultAddress")
              .success(res => {
                  // 触发地址更新
                  this.initData();
                  Toast({
                      duration: 1000,
                      message: this.$t('hint.settingSuccessful')+"~"
                  });
              })
              .error(err => {
                  // 错误提示
                  Toast(err);
                  this.isLoading = false;
                  // 触发地址更新
                  this.initData()
              })
              .send(
                  {},
                  {
                      id: info.id
                  }
              );
      },
      // 地址删除
      remove(info) {
          // 检查是否默认地址
          if (info.originInfo.isDefault) return Toast(this.$t('validator.defaultAddressCannotBeDeleted'));
          // CDP 埋点 [删除]
          this.CDP_track(info, '删除');
          Dialog.confirm({
                  title: this.$t('hint.addressDeletion'),
                  message: this.$t('hint.areYouSureToDeleteThisAddress')
              })
              .then(() => {
                  // 数据请求loading遮盖层
                  const toast = Toast.loading({
                      mask: true,
                      message: this.$t('comm.loading')
                  });

                  // 删除
                  this.$service("removeAddress")
                      .success(res => {
                          // 触发地址更新
                          this.initData()
                          toast.clear();
                      })
                      .error(err => {
                          // 触发地址更新
                          this.initData()
                          // 错误提示
                          Toast(err);
                      })
                      .send(
                          {},
                          {
                              id: info.id
                          }
                      );
              })
              .catch(() => {
                  // on cancel
              });
      },
      // 兼容ios滚动问题
      scrollShim(use, isCheckFooter) {
          if (isApp) return;
          let container = this.$refs.listMain;
          this.scollReset(container);
          this.$nextTick(() => {
              this.scollReset(container);
              requestAnimationFrame(() => {
                  this.scollReset(container);
                  requestAnimationFrame(() => {
                      use === true || this.scrollShim(true, isCheckFooter);
                  })
              })
          })
      },
      scollReset(container, isCheckFooter) {
          if (isApp) return;
          if (!container) return
          container.style.overflowY = 'auto'
          container.style.overflowY = 'scroll'
          let scrollTop = container.scrollTop;
          // 避免滚动最底部，导致ios中滑不动
          if ((container.scrollTop + container.offsetHeight) < container.scrollHeight) {
              if (!isCheckFooter) {
                  container.scrollTop = scrollTop = scrollTop + 1;
                  container.scrollTop = scrollTop - 1;
              }
          } else {
              container.scrollTop = scrollTop - 1;
          }
      },
      pageTouchEnd() {
          this.scrollShim(false, true);
      },
      pageTouchStart() {
          this.scollReset(this.$refs.listMain);
      },
      // CDP 埋点
      CDP_track(addressInfo, type) {
          // 地址信息
          const {consignName, sex, detailAddress, baseAddress, consignTel} = addressInfo.originInfo || {};
          // CDP 地址新增埋点  [修改地址]
          this.$CDP.track('c_modify_adress', {
              // 变更类型
              c_Change: type,
              // 地址
              c_address: baseAddress || '',
              // 联系人
              c_contact: consignName || '',
              // 手机号
              c_mobile: consignTel || '',
          })
      }
  }
};
</script>

<style lang="scss" scoped>
@import "~@assets/style/app/var.scss";

.base-layout-body {
  padding-bottom: 55px !important;
  background-color: $pageBg !important;
}

/deep/ .base-layout-footer {
  height: 55px !important;
  background: none !important;
}

.address-add {
  padding: 0 20px;
  width: 100%;
  border: none;

  button {
      width: 100%;
      height: 45px;
      color: white;
      font-size: 16px;
      border: none;
      border-radius: 5px;
      outline: none;
      background-color: rgba(255, 46, 46, 1);
      background: linear-gradient(
              to right,
              rgba(255, 98, 67, 1) 0%,
              rgba(255, 46, 46, 1) 100%
      );
  }
}

.loading-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  > div {
      height: 200px;
      display: flex;
      align-items: center;
      flex-direction: column;
  }

  p {
      color: #9c9c9c;
      font-size: 14px;
      padding-top: 20px;
      text-align: center;
  }
}

.gap {
  padding: 0 10px;

  &:after {
      content: "";
      width: 100%;
      display: block;
      transform: scale(1, 0.5);
      /*border-bottom: solid 1px #eee;*/
  }
}

.address-list-page {
  height: 100%;
  display: flex;
  overflow-y: scroll;
  flex-direction: column;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: $pageBg;
}

.address-list {
  padding-bottom: 10px;
  /*box-shadow: 0 0 3px 1px #eaeaea;*/
  &.focus {
      .address-radio {
          i {
              border-color: #ff5b40;
              background: #ff5b40;

              &:after {
                  content: "\e665";
              }
          }
      }

      position: relative;
      overflow: hidden;
      /*&::before {
                  top: -20px;
                  width: 40px;
                  height: 40px;
                  right: -20px;
                  display: block;
                  position: absolute;
                  content: "";
                  z-index: 5;
                  transform: rotate(-45deg);
                  background-color: #D0112B;
              }
              &::after {
                  top: 0;
                  right: 0;
                  width: 16px;
                  height: 16px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  color: white;
                  position: absolute;
                  z-index: 5;
                  content: "\e665";
                  font-family: "dmicon" !important;
                  font-size: 16px;
                  font-style: normal;
                  -webkit-font-smoothing: antialiased;
              }*/
  }
}

.address-info-content,
.address-location,
.address-action {
  background-color: white;
}

.address-info {
  border: none;
  padding-top: 5px;
  background-color: white;
}

.address-info-content {
  border: none;
  display: flex;
  padding: 3px 15px 5px;
  align-items: center;

  strong {
      color: #676767;
      font-weight: 500;
      font-size: 14px;
      padding-right: 15px;
  }

  span {
      flex: 1;
      color: gray;
      font-size: 14px;
  }
}

.address-location-plate {
  color: #676767;
  padding-left: 15px;
}

.address-location {
  color: #4c4848;
  min-height: 20px;
  font-size: 12px;
  padding: 0 15px;
  font-weight: 700;
  box-sizing: border-box;
  display: flex;
  align-items: center;

  span {
      color: #626262;
      font-size: 12px;
      font-weight: 500;
      padding: 0 0 0 5px;
      display: inline-block;
  }
}

.address-action {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
  border-top: solid 0.5px #f9f9f9;
}

.address-radio {
  display: flex;

  i {
      height: 20px;
      width: 20px;
      display: flex;
      border-radius: 100%;
      font-size: 12px;
      justify-content: center;
      justify-items: center;
      border: solid 1px gray;

      &:after {
          color: white;
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: "dmicon" !important;
          font-style: normal;
          -webkit-font-smoothing: antialiased;
      }
  }

  span {
      padding-left: 5px;
      font-size: 14px;
  }
}

.address-action-data {
  span {
      font-size: 14px;
      color: #07ABE6;
      padding: 0 10px;
      display: inline-flex;
      align-items: center;
      justify-content: center;

      &:nth-child(2) {
          color: #DB343E;
      }

      i {
          font-size: 16px;
      }
  }
}

.error-message {
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding-top: 100px;

  img {
      width: 90px;
      height: 90px;
      margin: 0 auto;
  }
}

.error-message i {
  color: #ccc;
  font-size: 60px;
}

.error-message p {
  font-size: 14px;
  color: #999;
}
</style>